"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M21 15h2v2h-2zm0 4h2v2h-2zm0-8h2v2h-2zm-8-8h2v2h-2zm8 4h2v2h-2zM1 7h2v2H1zm16-4h2v2h-2zm0 16h2v2h-2zM3 3H1v2h2zm20 0h-2v2h2zM9 3h2v2H9zM5 3h2v2H5zm-4 8v10h14V11zm2 8 2.5-3.21 1.79 2.15 2.5-3.22L13 19z"
}), 'PhotoSizeSelectLargeSharp');